import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonService } from 'src/app/_services/common.service';

@Component({
  selector: 'app-partner',
  templateUrl: './partner.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./partner.component.scss']
})
export class PartnerComponent implements OnInit {

  currentLanguage= this.commonService.currentLanguage;
  header: string = 'Join a Growing Network Of Partners';
  description: string = 'You can join our list of partners today and work with us to achieve the goal of achieving a safer business environment in various sectors';
  joinChat: boolean = false;
  imagePath = "../../../../assets/images/undraw_mobile_search_jxq5 1.png";
  hasBtn: boolean = true;
  buttonText = "Contact Us";
  routerButton = "/contact-us";

  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer,private commonService: CommonService) {
    iconRegistry.addSvgIcon(
      "reduce",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/svg/reduce_client.svg")
    );
    iconRegistry.addSvgIcon(
      "boost",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/svg/boost_service1.svg")
    );
    iconRegistry.addSvgIcon(
      "differentiate",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/svg/differentiate.svg")
    );
  }

  ngOnInit(): void {
    // this.commonService.loadScript('https://webforms.pipedrive.com/f/loader')
  }

}
